import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50675f7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "track-charts-btn-2",
  title: "Панель графиков по треку",
  style: {"cursor":"pointer"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "target-show" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/images/track_charts/charts.png",
      alt: "Граифики_по_треку"
    })
  ])
], -1))
const _hoisted_2 = {
  id: "chartHiddenSelect",
  class: "d-none"
}
const _hoisted_3 = ["value"]

import { inject, nextTick, onBeforeUnmount, ref, watch } from 'vue';

import RequestChartDataPanel from '@/App/Components/Chart/RequestChartDataPanel.vue';

import { ITreatmentPositions } from '../getPositionsFromOur';
import { TrackChartsPanel } from '@/Components/trackChartsPanel';
import DragElement_helper from '@/helpers/dragElement_helper';
import { fuelSettingsStore } from '@/App/store/FuelSettingsStore';
import { addCopyArray_helper } from '@/helpers/main_helper';
import { IFuels } from '@/App/store/IFuelSetting';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChartPopup',
  props: {
    name: null,
    interval: null,
    positions: null,
    map: null
  },
  setup(__props: any) {

const props = __props as {
  name: string;
  interval: { from: number; to: number };
  positions?: ITreatmentPositions;
  map: object | null;
}



const globalObjectsList = inject('globalObjectsList') as any;

const chartsPanel = ref<TrackChartsPanel>();

const requestChartDataPopup = ref<any>({
  visible: false,
  id: '',
  fuelSettings: null,
  category: '',
  name: '',
});
const chartsByObjectId = ref<{ [key: string]: any }>({});

watch(
  () => props.positions,
  async (positions) => {
    if (positions) {
      await nextTick();

      const { defaultChartNames, defaultDisplayedCharts } = getDefaultCharts();

      chartsPanel.value = new TrackChartsPanel({
        buttonId: 'track-charts-btn-2' as any,
        positionsListId: 'chartHiddenSelect',
        DragElement_helper,
        leafletMain: props.map as any,
        globalObjects: {
          globalPositions: { [positions.objId]: props.positions },
        } as any,
        defaultChartNames,
        defaultDisplayedCharts,
        notOtherQueries: true,
      });

      chartsByObjectId.value[positions.objId] = {
        saved: addCopyArray_helper(defaultChartNames),
        checked: addCopyArray_helper(defaultChartNames),
        levels: [],
      };

      chartsPanel.value.displayRequestPopup = displayRequestChartsPopup;
    }
  },
  { immediate: true },
);

onBeforeUnmount(() => {
  if (chartsPanel.value) chartsPanel.value.destroy();
});

const getDefaultCharts = () => {
  const charts: {
    defaultChartNames: string[];
    defaultDisplayedCharts: string[];
  } = {
    defaultChartNames: [],
    defaultDisplayedCharts: [],
  };

  if (!props.positions) return charts;

  const obj = globalObjectsList[props.positions.objId];

  const isSpecVehicle = obj?.category.toString().startsWith('4');

  charts.defaultChartNames = isSpecVehicle
    ? ['engine_time', 'active_time', 'hirpm_notactime']
    : ['speed', 'distance'];
  charts.defaultDisplayedCharts = isSpecVehicle
    ? ['engine_time', 'active_time', 'hirpm_notactime']
    : ['distance'];

  return charts;
};

const displayRequestChartsPopup = (e: any) => {
  const { id, from, to } = e.target.dataset;

  if (!fuelSettingsStore || !('getSettingById' in fuelSettingsStore)) return;

  const obj = globalObjectsList[id];

  const category = obj?.category;

  requestChartDataPopup.value = {
    visible: true,
    id,
    fuelSettings: fuelSettingsStore.getSettingById(id)?.fuels,
    from,
    to,
    category,
    name: obj?.name,
  };
};

function addCharts({
  chartNames: checkedCharts,
  columns,
  levels,
  treatmentPositions,
}: any) {
  const { id, fuelSettings } = requestChartDataPopup.value;

  const checkedFuelSettings: { [fuelKey: string]: IFuels[] } = {};
  for (const fuelKey in fuelSettings) {
    checkedFuelSettings[fuelKey] = [];

    const setting = fuelSettings[fuelKey].find((setting: IFuels) =>
      levels.includes(setting.tDetailNum),
    );

    if (setting) {
      checkedFuelSettings[fuelKey].push(setting);
    }
  }

  chartsByObjectId.value[id].saved = [
    ...new Set([
      ...chartsByObjectId.value[id].saved,
      ...checkedCharts,
      ...levels,
    ]),
  ];
  chartsByObjectId.value[id].checked = checkedCharts;
  chartsByObjectId.value[id].levels = levels;

  chartsPanel.value?.addCharts(id, {
    chartNames: checkedCharts,
    levels,
    columns: columns.filter((c: string) => c != 'time'),
    fuelSettings: checkedFuelSettings,
    positions: treatmentPositions,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("select", _hoisted_2, [
      _createElementVNode("option", {
        value: props.positions?.objId
      }, null, 8, _hoisted_3)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (chartsByObjectId.value[requestChartDataPopup.value.id])
        ? (_openBlock(), _createBlock(RequestChartDataPanel, {
            key: 0,
            modelValue: requestChartDataPopup.value.visible,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((requestChartDataPopup.value.visible) = $event)),
            id: requestChartDataPopup.value.id,
            "fuel-settings": requestChartDataPopup.value.fuelSettings,
            from: requestChartDataPopup.value.from,
            to: requestChartDataPopup.value.to,
            category: requestChartDataPopup.value.category,
            "chart-names": chartsByObjectId.value[requestChartDataPopup.value.id].checked,
            saved: chartsByObjectId.value[requestChartDataPopup.value.id].saved,
            levels: chartsByObjectId.value[requestChartDataPopup.value.id].levels,
            positions: props.positions,
            name: requestChartDataPopup.value.name,
            onAddCharts: addCharts
          }, null, 8, ["modelValue", "id", "fuel-settings", "from", "to", "category", "chart-names", "saved", "levels", "positions", "name"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})